import styled from 'styled-components';
import { Z_INDEXES } from '../../../src/styled/global-variables';
export const Wrapper = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${Z_INDEXES.OVERLAY};
  width: 100vw;
  height: 100vh;
  background-color: ${({ $color }) => $color};
  visibility: ${({ $isHidden }) => ($isHidden ? 'hidden' : 'initial')};
  backdrop-filter: blur(12px);
`;
